import axios from "@/plugins/axios";

let url = "/api/console/mes/schedules";

export default {
    gets(data) {
        return axios.get(url, data).then((result) => result.data);
    },
};
